import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const UploadCSVDialog = ({ show, onClose, onUpload }) => {
  const [file, setFile] = useState(null);
  const [type, setType] = useState("studyprogram");
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    if (e.target.files[0]) setError("");
  };

  const handleUpload = () => {
    if (!file) {
      setError("Please select a CSV / Excel file to upload.");
      return;
    }
    onUpload(file, type);
    setFile(null);
    setType("studyprogram");
    setError("");
    onClose();
  };

  const handleClose = () => {
    setFile(null);
    setType("studyprogram");
    setError("");
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>CSV / Excel Operations</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formType" className="mb-3">
          <Form.Label>Type</Form.Label>
          <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="studyprogram">Study Program</option>
            <option value="parttime">Parttime</option>
          </Form.Select>
        </Form.Group>
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Upload CSV / Excel</Form.Label>
          <Form.Control type="file" onChange={handleFileChange} />
          {error && <div className="text-danger mt-2">{error}</div>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleUpload}>
          Upload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadCSVDialog;
